import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Typography, Tabs, Tab, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import LoadingOverlay from './LoadingOverlay';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'min(520px, 95vw)',
  bgcolor: '#fff',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  maxHeight: '90vh',
  overflowY: 'auto',
};

const LoginRegisterModal = ({ open, onClose, onSuccess }) => {
  const { login, register, loading, error } = useAuth();
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ name: '', email: '', password: '', contact: '', address: '' });
  const [submitError, setSubmitError] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setSubmitError('');
    try {
      if (mode === 'login') {
        await login({ email: form.email, password: form.password });
      } else {
        await register({
          name: form.name,
          email: form.email,
          password: form.password,
          contact: form.contact,
          address: form.address,
        });
      }
      onSuccess?.();
      onClose();
    } catch (fetchError) {
      setSubmitError(fetchError?.message || 'Unable to complete request');
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <>
        <LoadingOverlay open={loading} message={mode === 'login' ? 'Logging in...' : 'Registering...'} />
        <Box sx={modalStyle}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            {mode === 'login' ? 'Login to Vedamarga' : 'Register a new account'}
          </Typography>

          <Tabs
            value={mode}
            onChange={(_, value) => setMode(value)}
            sx={{ mb: 2 }}
          >
            <Tab value="login" label="Login" />
            <Tab value="register" label="Register" />
          </Tabs>

          {submitError || error ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {submitError || error}
            </Alert>
          ) : null}

          {mode === 'register' && (
            <TextField
              name="name"
              label="Full name"
              value={form.name}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          )}

          <TextField
            name="email"
            label="Email"
            value={form.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <TextField
            name="password"
            label="Password"
            type="password"
            value={form.password}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          {mode === 'register' && (
            <>
              <TextField
                name="contact"
                label="Phone number"
                value={form.contact}
                onChange={handleChange}
                fullWidth
                margin="normal"
                helperText="Enter the phone number for registration"
              />
              <TextField
                name="address"
                label="Address"
                value={form.address}
                onChange={handleChange}
                fullWidth
                margin="normal"
                helperText="You can set your preferred delivery address here"
              />
            </>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {mode === 'login' ? 'Login' : 'Register'}
          </Button>
        </Box>
      </>
    </Modal>
  );
};

export default LoginRegisterModal;
